module.exports = "<app-page><div class=\"flex\" *ngIf=\"authorized\"><locations-filter-sheet [fg]=\"fg\" (filterChanged)=\"onFilterChanged($event)\"></locations-filter-sheet><my-location-sale-list [locationinvoiceOpen]=\"locationinvoiceOpen\" [locationinvoiceClosed]=\"locationinvoiceClosed\" [locationFilter]=\"_locationFilter\" [empty]=\"empty\"> </my-location-sale-list></div><user-feedback [hidden]=\"authorized || loading\" type=\"info\" message=\"User - Not Authorized\"></user-feedback></app-page>";


//////////////////
// WEBPACK FOOTER
// ./src/app/location/location/location-index.component.pug
// module id = 933
// module chunks = 0